<template>
    <div class="generation">
        <div class="slider-wrapper">
            <div class="sliders"
                :style="{ transform: `translateX(${positionX})` }">
                <template v-for="(sprouter, index) in sprouters">
                    <Sprouter
                        :key="index"
                        :isActive="isActive(index)"
                        :disabled="isDisabled(index)"
                        :img="sprouter.img"
                        :name="sprouter.name"
                        :position="sprouter.position"
                        @click.native="activate(index)"
                        v-scroll-to="{
                            el: '.sprouters-experience-container',
                            offset: -240,
                        }">
                    </Sprouter>
                </template>
            </div>            
            <template v-if="showButton">
                <div class="button-prev"
                    :class="{ 'button-disabled': prevBtnDisable }"
                    slot="button-prev"
                    @click="clickPrevBtn">         
                </div>
                <div class="button-next" 
                    slot="button-next"
                    :class="{ 'button-disabled': nextBtnDisable }"
                    @click="clickNextBtn">         
                </div>
            </template>
        </div>
        <div class="sprouters-experience-container">
            <template v-for="(sprouter, index) in sprouters">
                <SprouterDetail
                    :key="index"
                    v-show="isActive(index)"
                    :photo="sprouter.photo"
                    :name="sprouter.name"
                    :position="sprouter.position"
                    :article="sprouter.article"
                    :activeGeneration="activeGeneration"
                >
                </SprouterDetail>
            </template>
        </div>      
    </div>    
</template>

<script>
import Sprouter from './Sprouter.vue';
import SprouterDetail from './SprouterDetail.vue';

export default {
    name: 'Generation',
    props: ['sprouters', 'activeGeneration'],
    components: {
        Sprouter,
        SprouterDetail
    },
    data: function() {
        return {
            activeSprouter: 0,
            displayIndex: 0,
            displayNum: 5,
            slideWidth: 280,
            slidesOffsetBefore: 190,
            arrowOffset: 130,
        }
    },
    methods: {
        isActive: function(sprouterIndex) {
            if (sprouterIndex == this.activeSprouter) {
                return true;
            }
            return false;
        },
        activate: function(sprouterIndex) {
            this.activeSprouter = sprouterIndex;
        },
        getDisplayNum: function() {
            let winWidth = window.innerWidth;

            let displayNum = Math.floor(
                (winWidth - this.arrowOffset - this.slidesOffsetBefore) / 
                this.slideWidth);

            this.displayNum = displayNum > 0 ? displayNum : 1;

            if (this.displayNum == 1) this.activeSprouter = this.displayIndex;
        },
        isDisabled: function(sprouterIndex) {        
            if (sprouterIndex >= this.displayIndex && 
                sprouterIndex <= this.displayIndex + this.displayNum -1) {
                return false;
            }
            else {
                return true;
            }           
        },
        clickPrevBtn: function() {
            this.displayIndex --;
            if (this.isDisabled(this.activeSprouter)) {
                this.activeSprouter = this.displayIndex + this.displayNum - 1;
            }
        },
        clickNextBtn: function() {
            if (this.displayIndex < this.sprouters.length - this.displayNum) {
                this.displayIndex ++;
            }
            if (this.isDisabled(this.activeSprouter)) {
                this.activeSprouter = this.displayIndex;
            }
        }
    },
    computed: {
        positionX: function() {
            let adjustment = 0;

            if (this.showButton) {
                if (this.displayNum == 1) {
                    adjustment = this.slideWidth / 2 +
                                 this.displayIndex * this.slideWidth + 10;
                    return `calc(50vw - ${adjustment}px)`;
                }

                adjustment = this.slidesOffsetBefore - 
                             this.displayIndex * this.slideWidth
                return `${adjustment}px`;
            }
            else {
                adjustment = this.sprouters.length / 2 * this.slideWidth + 20;
                return `calc(50vw - ${adjustment}px)`;
            }   
        },
        showButton: function() {
            return this.sprouters.length > this.displayNum ? true : false;        
        },
        prevBtnDisable: function() {
            return this.displayIndex == 0 ? true : false;
        },
        nextBtnDisable: function() {
            return this.displayIndex == (this.sprouters.length - this.displayNum) ? true : false;
        }
    },
    mounted: function() {
        let winWidth = window.innerWidth;
        this.getDisplayNum();
        window.addEventListener("resize", this.getDisplayNum);
    }
}
</script>

<style scoped lang="scss">
    @import "../../static/styles/palette.scss";

    .generation {
        & .slider-wrapper {
            display: flex;
            position: relative;
            width: 100%;
            overflow-x: hidden;
            z-index: 10;

            & .sliders {
                display: flex;
                position: relative;
                min-width: 3000px;
                transition: transform 0.8s;
                transition-timing-function: ease-in-out;
            }

            & .button-prev {
                position: absolute;    
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 30px 30px 30px 0;
                border-color: transparent $blue transparent transparent;
                left: 100px;
                top: 40%;
                z-index: 15;
                cursor: pointer;
            }

            & .button-next {
                position: absolute;                
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 30px 0 30px 30px;
                border-color: transparent transparent transparent $blue;
                right: 100px;
                top: 40%;
                z-index: 15;
                cursor: pointer;
            }

            & .button-disabled {
                opacity: 0.3;
                cursor: auto;
                pointer-events: none;
            }
        }

        & .sprouters-experience-container {
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            margin-top: -35px;
            width: 100%;
            height: 460px;
            z-index: 0;
            background-color: $darkGray;
        }
    }

    @media all and (max-width: 640px) {
        .generation {

            & .slider-wrapper {

                & .button-prev {
                    left: 60px;
                }

                & .button-next {
                    right: 60px;
                }
            }            
        }
    }

    @media all and (max-width: 480px) {
        .generation {

            & .slider-wrapper {

                & .button-prev {
                    left: 40px;
                }

                & .button-next {
                    right: 40px;
                }
            }            
        }
    }

    @media all and (max-width: 320px) {
        .generation {

            & .slider-wrapper {

                & .button-prev {
                    left: 20px;
                }

                & .button-next {
                    right: 20px;
                }
            }            
        }
    }
</style>



// WEBPACK FOOTER //
// Generation.vue?45079322